import script from "./CoreWebVitals2025Advanced.vue?vue&type=script&setup=true&lang=js"
export * from "./CoreWebVitals2025Advanced.vue?vue&type=script&setup=true&lang=js"

import "./CoreWebVitals2025Advanced.vue?vue&type=style&index=0&id=43daf432&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43daf432"]])

export default __exports__